import script from "./Facturacion.vue?vue&type=script&setup=true&lang=js"
export * from "./Facturacion.vue?vue&type=script&setup=true&lang=js"

import "./Facturacion.vue?vue&type=style&index=0&id=6e21ede3&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e21ede3"]])

export default __exports__